import { Flex, ListItem, Text, List, Box, Badge, Spinner, Button } from "@chakra-ui/react";
import { FC, Fragment } from "react";
import { Card } from "../..";
import { IStbDevice } from "../../../../hooks/useStbList";
import { formatClock, timestampToDateString } from "../../../utils";
import { useNavigate } from "react-router-dom";

const mockData = {
    model: "ARRIS 4302",
    serialNumber: "SERIAL010101",
    macAddress: "11:22:33:44:55:66",
    ipAddress: "192.168.0.1",
    creationDate: Math.floor(Date.now() / 1000),
};

const StbDevice: FC<any> = ({ stbDeviceData }) => {
    const navigate = useNavigate()

    const {
        model,
        serialNumber,
        macAddress,
        ipAddress,
        creationDate,
        id
    } = stbDeviceData;

    return (
        <Button
            bg="gray.100"
            borderRadius="md"
            p={4}
            mb={4}
            mt={4}
            width="100%"
            minW="220px"
            minH="200px"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            onClick={() => {
                navigate(`tv_device/${id}`);
            }}
        >
            <Text fontWeight="bold" fontSize="md">
                {model || "Brak nazwy"}
            </Text>

            <Flex mt={2} color="gray.700" flexDir={'column'} alignItems={'flex-start'}>
                <Text fontWeight="medium">  S/N: {serialNumber || "Brak numeru"}</Text>
                <Text fontWeight="medium" mt={2}>  MAC: {macAddress || "Brak numeru"}</Text>
                <Text fontWeight="medium" mt={2}>  Adres IP: {ipAddress || "Brak adresu ip"}</Text>
            </Flex>

            <Text fontSize="xs" textAlign="left" color="gray.500" mt={4}>
                {creationDate
                    ? `Odczytano ${timestampToDateString(Number(creationDate) * 1000) + ' ' + formatClock(Number(creationDate) * 1000)}`
                    : "Brak daty"}
            </Text>
        </Button>
    );
};


export interface IStbDevicesCard {
    stbDevices: any[];
}


export const StbDevicesCard: FC<IStbDevicesCard> = ({ stbDevices }) => {

    return (
        <Card title="Telewizyjne" titleStyle={{ marginLeft: '5px' }} >
            <Flex overflowX="auto" gap={4} px={2}>
                {stbDevices.length
                    ? stbDevices.map((data) => (
                        <Box key={data.id} minW="240px" flex="0 0 auto" m={"3px 5px"}>
                            <StbDevice stbDeviceData={data} />
                        </Box>
                    ))
                    : null}
            </Flex>

        </Card>
    );
};
